<template>
	<div class="page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class='d-flex justify-space-between'>
				<ButtonBack />
			</div>
			<v-card
				class='profile-page pa-7 mt-5'
				style='border-radius: 10px; max-width: 600px;'
				flat
			>
				<div
					v-if='userFlag'
					:style='{backgroundColor: userFlag.flag_bg_color}'
					class="user-preview-card__user-flag"
				>
					<span :style='{backgroundColor: userFlag.flag_bg_color, color: userFlag.flag_txt_color}'>
						{{userFlag.flag_name}}
						<span :style='{backgroundColor: userFlag.flag_bg_color}'></span>
					</span>
				</div>
				<v-card-text class='mt-5'>
					<div
						v-if='!isAttendeeEmpty'
					>
	
						<div class='user__brief-info-with-avatar my-10'>
							<div class="user__brief-info__title mb-5">
								<Avatar
									:avatar='avatarPath'
									size='140px'
									border-radius='square'
									class='user__avatar mr-10'
								/>
	
								<div class='user__brief-description'>
									<h1 class='user__brief-description__username mb-3'>{{ userName }}</h1>
	
									<div class='d-flex flex-column'>
										<span
											v-if='companyName'
											class='user__brief-description__company mb-1'
										>
											{{ companyName }}
										</span>
										<span
											v-if='heldPosition'
											class='user__brief-description__held-position mb-1'
										>
											{{ heldPosition }}
										</span>
	
										<span
											v-if='location'
											class='user__brief-description__location mb-1 d-flex'
										>
											<Icon 
												type="pin"
												:size="16"
												color="var(--location-color)"
												:pr="4"
											/>
											<span>{{ location }}</span>
										</span>
									</div>
								</div>
							</div>
							<v-btn 
								class="user__brief-action-btn elevation-0 px-9" 
								@click="switchNoteFormModal"
							>
								{{ attendee.follow_note ? 'Edit Note' : 'Add Note' }}
							</v-btn>
						</div>
	
						<div v-if="attendee.follow_note" class="user__note">
							<h3 class="mb-3">Note</h3>
							<span>
								{{ attendee.follow_note }}
							</span>
						</div>
	
					<div v-for="(field, index) in allowFields" :key="field.field" :class="fieldClass(allowFields, index)">
						<h3 v-if="!allowFields[index - 1] || allowFields[index - 1].section !== field.section" class="mb-3">
							{{ field.section }}
						</h3>
						<div v-if="field.type === 'email'">
							<a :href="'mailto:' + field.value" style="color: var(--ceil-detail-text-color)">
								{{ field.value }}
							</a>
						</div>
						<div 
							v-else-if="field.section === 'Network' && (index === 0 || allowFields[index - 1].section !== 'Network')" 
							class="user-profile-page__network pt-4"
						>
							<a 
								v-for="item in networkFields" 
								:key="item.field" 
								:href="item.value" 
								target="_blank"
							>
								<Icon 
									:type="networkFieldType(item.type)"
									:size="28"
								/>
							</a>
						</div>
						<div v-else-if="field.type === 'phone'" class="py-3 d-flex">
							<Icon 
							type="phone"
							color="#a0a0a0"
							:pr="12"
							:size="22"
						/>
							<a @click="copyPhone(field.value)" :href="null" style="text-decoration: underline; color: var(--ceil-detail-text-color)">
								{{ field.value }}
							</a>
						</div>
						<v-card-text v-else-if="field.type === 'html'" v-html="field.value" />
						<div v-else-if="field.section !== 'Network'" class="mb-4">
							<span class="font-weight-bold mr-2">
								{{ field.title }}:
							</span>
							<span>
								{{ field.value }}
							</span>
						</div>
					</div>
				</div>
	
					<v-skeleton-loader
						style='width: 100%;'
						v-bind='attrs'
						type='card'
						v-if='isAttendeeEmpty'
					>
					</v-skeleton-loader>
				</v-card-text>
				<div v-if="isShowNoteFormModal">
					<NoteFormModal
						v-on:closeModal="switchNoteFormModal"
						:show="isShowNoteFormModal"
						:id="userId"
						:username="userName"
						:edit="!!attendee.follow_note"
						:note="attendee.follow_note || null"
						userPage
					/>
				</div>
			</v-card>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import Avatar from '@/components/Avatar'
import NoteFormModal from '../../components/Modals/NoteFormModal.vue'
import ButtonBack from '../../components/ButtonBack.vue'
import Block from '@/mixins/Block.js'
import PageBlocked from '@/components/PageBlocked'
import twitterLogo from '@/assets/images/twitterX-logo.svg'

export default {
	name: 'ProfilePage',
	mixins: [Block],
	components: {
		Avatar,
		NoteFormModal,
		PageBlocked,
		ButtonBack
	},
	computed: {
		...mapGetters('auth', ['profile', 'isAuthenticated']),
		...mapGetters('event', ['attendee']),
		...mapGetters('settings', ['backUser']),

		isAttendeeEmpty() {
			const {
				user_id: userId,
			} = this.attendee || {}

			return userId !== +this.$route.params.id
		},

		allowFields() {
				return this.attendee.public.filter(field => field.value)
		},
		networkFields() {
			return this.attendee.public.filter(field => field.section === 'Network' && field.value)
		},
		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},
		userFlag() {
			const {userFlag: flag} = this.attendee || {};

			return flag
		},
		userId() {
			const { user_id: userId } = this.attendee || {}
			return userId
		},

		// short profile
		location() {
			const { location_profile_row: location = {} } = this.attendee || {}
			return location
		},
		userName() {
			const { visible_username: name } = this.attendee || {}
			return name
		},
		avatarPath() {
			const { user_logo: userLogo } = this.attendee || {}
			return userLogo
		},
		heldPosition() {
			const { third_profile_row: heldPosition } = this.attendee || {}
			return heldPosition
		},
		companyName() {
			const { second_profile_row: company } = this.attendee || {}
			return company
		},
	},
	methods: {
		...mapActions('event', ['getAttendee']),
		...mapActions('app', ['showAlert', 'hideAlert']),

		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		dateCreated(originalDate) {
			return new Date(originalDate * 1000).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			})
		},
		getTypeFieldsFromUrl(url) {
			const parts = url.split('/')
			return parts[parts.length - 1]
		},
		switchNoteFormModal() {
			this.isShowNoteFormModal = !this.isShowNoteFormModal
		},
		formatUrl(url) {
			if (!url) {
				return '';
			}

			if (!url.startsWith('http://') && !url.startsWith('https://')) {
				if (url.startsWith('www.')) {
					url = 'https://' + url;
				} else {
					url = 'https://www.' + url;
				}
			}
			return url;
		},
		copyPhone(value) {
			if (!this.isShowAlert) {
				const phone = value.replace(/\D/g, '');

				this.$copyText(phone).then(() => {
					const closeTimeout = setTimeout(() => {
						this.hideAlert('')
					}, 3000)

					this.showAlert({ message: 'Phone number copied successfully.', closeTimeout })
				})
			}
		},
		fieldClass(allowFields, index) {
			if (index === 0 || allowFields[index].section !== allowFields[index - 1].section) {
				return 'mt-8'
			} else if (!allowFields[index + 1] || allowFields[index + 1].section !== allowFields[index].section) {
				return 'mb-8'
			} else {
				return ''
			}
		},
		networkFieldType(type) {
			if (type === 'url') {
				return 'link'
			} else {
				return type
			}
		}
	},
	data() {
		return {
			searchIcon,
			twitterLogo,
			successMessage: false,
			errorMessage: false,
			isShowNoteFormModal: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			socialFieldNames: [
				'user_linkedin',
				'user_facebook',
				'user_twitter',
				'user_custom_url',
			],
			phoneFieldNames: [
				'user_work_phone',
				'user_cell_phone',
			],
			pageBlockedName: 'users'
		}
	},
	created() {
		if (this.$route.params.id && (!this.isBlocked || this.isBlocked === null)) {
			this.getAttendee(+this.$route.params.id)
		}
	},
}
</script>

<style lang='scss'>
.v-list-item {
	padding: 0;

	.v-icon {
		margin-right: 12px;
	}
}

.user-page {
	font-family: Montserrat, sans-serif;
	max-width: 600px;
	width: 100%;
	border-radius: 10px !important;
	margin-bottom: 30px;

	@media (max-width: 480px) {
		margin-bottom: 12px;
	}
}

.user {
	&__home-address,
	&__work-address {
		background: rgb(251, 251, 251);
		border-radius: 12px;
		border: 1px solid rgb(226, 226, 226);
	}

	&__brief-info-avatar-wrapper {
		display: flex;

		@media (max-width: 768px) {
			flex-direction: column;
			align-items: center;
		}
	}
	
	&__avatar {
		@media (max-width: 768px) {
			margin-left: 40px;
			margin-bottom: 20px;
		}
	}

	&__brief-description {
		&__location {
			margin-left: -6px;
			word-break: break-word;
		}
	}
	&__brief-action-btn {
		font-size: 16px !important;
		font-weight: 700;
		text-transform: capitalize;
		border-radius: 8px;
		border: 2px solid var(--accent-color) !important;
		color: var(--accent-color) !important;
		background-color: #fff !important;
	}
	&__brief-description__held-position, &__brief-description__company, &__brief-description__name {
		word-break: break-word;
	}
	&__phone-numbers > ul,
	&__networks > ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}
	&__networks-link {
		word-break: break-word;
	}
	&__brief-info__title {
		display: flex;

		@media (max-width: 620px) {
			flex-direction: column;
			align-items: center;

			h1 {
				text-align: center;
			}
		}
	}
}
</style>
